import { BlogSection } from '@/types/blog';

export const praxis: BlogSection = {
  id: 'praxis',
  title: 'Praxis: Wie das aussieht',
  content: `
    <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mb-4">Im Geschäft:</h3>
    
    <div class="grid md:grid-cols-2 gap-6 my-6">
      <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 p-6 rounded-lg">
        <h4 class="font-bold text-red-800 dark:text-red-200 mb-3">❌ Haben-Modus</h4>
        <ul class="space-y-2 text-red-700 dark:text-red-300 text-sm">
          <li>• „Ich muss 50 Kunden haben."</li>
          <li>• „Ich muss auf LinkedIn 10.000 Follower haben."</li>
          <li>• „Ich muss eine Million Umsatz haben."</li>
        </ul>
      </div>

      <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 p-6 rounded-lg">
        <h4 class="font-bold text-green-800 dark:text-green-200 mb-3">✅ Sein-Modus</h4>
        <ul class="space-y-2 text-green-700 dark:text-green-300 text-sm">
          <li>• „Ich schaffe Räume, in denen Menschen wachsen."</li>
          <li>• „Ich bin präsent für die, die Resonanz spüren."</li>
          <li>• „Ich praktiziere Wertschöpfung, nicht Wertextraktion."</li>
        </ul>
      </div>
    </div>

    <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mt-8 mb-4">In Beziehungen:</h3>
    
    <div class="grid md:grid-cols-2 gap-6 my-6">
      <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 p-6 rounded-lg">
        <h4 class="font-bold text-red-800 dark:text-red-200 mb-3">❌ Haben-Modus</h4>
        <ul class="space-y-2 text-red-700 dark:text-red-300 text-sm">
          <li>• „Ich habe einen Partner." (Besitz)</li>
          <li>• „Ich muss geliebt werden." (Bedürftigkeit)</li>
          <li>• „Ich will, dass du dich änderst." (Kontrolle)</li>
        </ul>
      </div>

      <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 p-6 rounded-lg">
        <h4 class="font-bold text-green-800 dark:text-green-200 mb-3">✅ Sein-Modus</h4>
        <ul class="space-y-2 text-green-700 dark:text-green-300 text-sm">
          <li>• „Ich praktiziere Liebe." (Haltung)</li>
          <li>• „Ich bin liebesfähig." (Ressource)</li>
          <li>• „Ich sehe dich, wie du bist." (Respekt)</li>
        </ul>
      </div>
    </div>

    <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mt-8 mb-4">Zu dir selbst:</h3>
    
    <div class="grid md:grid-cols-2 gap-6 my-6">
      <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 p-6 rounded-lg">
        <h4 class="font-bold text-red-800 dark:text-red-200 mb-3">❌ Haben-Modus</h4>
        <ul class="space-y-2 text-red-700 dark:text-red-300 text-sm">
          <li>• „Ich muss erfolgreich sein."</li>
          <li>• „Ich muss glücklich sein."</li>
          <li>• „Ich muss meine Ziele erreichen."</li>
        </ul>
      </div>

      <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 p-6 rounded-lg">
        <h4 class="font-bold text-green-800 dark:text-green-200 mb-3">✅ Sein-Modus</h4>
        <ul class="space-y-2 text-green-700 dark:text-green-300 text-sm">
          <li>• „Ich bin im Prozess."</li>
          <li>• „Ich praktiziere Einklang."</li>
          <li>• „Ich bin, was ich tue."</li>
        </ul>
      </div>
    </div>
  `
};
